module.exports = __webpack_public_path__ + "assets/images/icons/icon_vaccine-grey.svg?v=f9cb48af";